var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "web_doc_icon",
    "data-name": "web doc icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.996,
    height: 46,
    viewBox: "0 0 39.996 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6945",
    "data-name": "Group 6945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M88.665-500.938a14.736,14.736,0,0,0-4.912,2.947,57.37,57.37,0,0,0-5.413,5.4c-1.7,2.093-2.764,3.869-2.967,5-.067.365-.087,5.05-.067,14.017.019,12.664.039,13.518.2,14.056a6.481,6.481,0,0,0,3.236,3.869c1.445.682.636.643,13.532.643,11.009,0,11.692-.009,12.28-.173a6.452,6.452,0,0,0,4.373-4.339,12.18,12.18,0,0,0,.221-1.853l.058-1.267h-3.092l-.039,1.219a3.29,3.29,0,0,1-.26,1.661,3.452,3.452,0,0,1-1.406,1.421l-.482.259-11.6.029-11.6.019-.539-.24a3.276,3.276,0,0,1-1.531-1.44l-.26-.48-.029-13.5L78.36-487.2l2.813-.048c3.14-.048,3.448-.1,4.652-.72A7.141,7.141,0,0,0,88.4-490.53c.626-1.2.674-1.507.722-4.637l.048-2.8,7.387.019,7.378.029.482.259a3.229,3.229,0,0,1,1.435,1.517l.251.528v16.081h3.092l-.039-8.189c-.029-9.092.009-8.506-.7-9.956a6.9,6.9,0,0,0-2.591-2.612c-1.4-.72-.963-.691-9.294-.711C92.421-501.015,88.906-500.986,88.665-500.938Z",
    transform: "translate(-75.299 501.007)",
    fill: "#00a99d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6944",
    "data-name": "Group 6944",
    transform: "translate(9.272 22.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6943",
    "data-name": "Group 6943",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6942",
    "data-name": "Group 6942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M746.4,144.43H744.69v1.965h1.684c.622,0,1.163-.2,1.163-.942S747.076,144.43,746.4,144.43Z",
    transform: "translate(-722.442 -137.139)",
    fill: "#00a99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M302.029-9.475c-.992-.992.347-.906-14.264-.925-10.951-.019-12.839,0-13.282.125a2.766,2.766,0,0,0-1.541.963c-.722.828-.732.867-.732,5.817,0,5.134-.01,5.056.906,5.981.992.982-.308.906,14.457.906s13.465.077,14.457-.906c.915-.925.905-.848.905-5.981S302.944-8.551,302.029-9.475ZM283.743.072h-1.564L280.966-4.8h-.02L279.753.072h-1.594l-1.894-7.157h1.574l1.132,4.872h.02l1.243-4.872h1.473l1.223,4.932h.02l1.173-4.932h1.544Zm8.079,0h-5.433V-7.085h5.352v1.323h-3.779v1.534h3.468v1.223h-3.468v1.754h3.859Zm4.531,0h-3.468V-7.085h3.368c1.363,0,2.286.441,2.286,1.774a1.57,1.57,0,0,1-.972,1.494A1.747,1.747,0,0,1,298.879-2C298.879-.549,297.646.072,296.353.072Z",
    transform: "translate(-272.21 10.407)",
    fill: "#00a99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M747.256,86.922c0-.682-.521-.822-1.083-.822H744.7v1.674h1.594C746.845,87.774,747.256,87.523,747.256,86.922Z",
    transform: "translate(-722.451 -81.556)",
    fill: "#00a99d"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.ba99221e9ca446e5b285dc1bed8e7b66.svg";
export { ForwardRef as ReactComponent };